import { connect } from 'react-redux';
import { actions } from '../../../../../../redux/modules/administrativos/administrativos';
import AdministrativosList from "./Administrativos";


const ms2p = (state) => {
  return {
    ...state.administrativos,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(AdministrativosList);
